import { EntityLock } from "../../entity/EntityLock";

export class DtoLocksDeleteRes extends EntityLock {
  public message: string | null = null;
}
